const firebaseConfig = {
  apiKey: "AIzaSyD7dGKdtgCvlFvw-aWGCN-L0_2cR315ff4",
  authDomain: "gcb-greenhub-uat.firebaseapp.com",
  projectId: "gcb-greenhub-uat",
  storageBucket: "gcb-greenhub-uat.firebasestorage.app",
  messagingSenderId: "324060309355",
  appId: "1:324060309355:web:efebee9155ffab4c8b8e2e",
  measurementId: "G-RPYBTGL1VN",
  deploymentId:  "gcb-greenhub-uat"
};

export const environment = {
  production: false,
  firebase: firebaseConfig,
  UAT: true
};
